import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCCmNqqMkSqRbe5_zueHlpHI_SbU1PiPz0",
  authDomain: "meat-meal-planner.firebaseapp.com",
  projectId: "meat-meal-planner",
  storageBucket: "meat-meal-planner.firebasestorage.app",
  messagingSenderId: "998444740866",
  appId: "1:998444740866:web:5f267095d0b6fc78d1521b",
  measurementId: "G-P27CX0N9WJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

// Analytics disabled
export const analytics = null;